export default __webpack_public_path__ + "static/media/points.1d25d08b.svg";